/* PKW GUTACHTER - Karussell
   ==========================================================================
   Macht aus einer schlichten Liste (.team mit .team-p darin) ein
   endloses Karussell mit Tiefe: die mittlere Karte steht gross und
   gerade, die Nachbarn sind kleiner, blasser und leicht weggedreht.

   WARUM UEBERHAUPT EIN KARUSSELL

   Im Team sind vier Personen. Als Raster ergab das drei in der ersten
   Reihe und eine allein in der zweiten - eine Anordnung, die aussieht,
   als sei jemand vergessen worden.

   WARUM NICHT REACT

   Vorlage ist die Machart von reactbits.dev: ziehen, einrasten, Tiefe,
   Punkte, Selbstlauf, endlos. Die Bausteine dort sind React-Komponenten
   mit Framer Motion. Beides in ein Shopify-Theme zu holen, das sonst ohne
   Rahmenwerk auskommt, hiesse rund 150 Kilobyte JavaScript fuer vier
   Portraits - auf jeder Seite, auf der das Theme laedt. Das Verhalten ist
   hier deshalb nachgebaut, in gut fuenf Kilobyte.

   WIE DAS ENDLOSE LAUFEN FUNKTIONIERT

   Es gibt keinen Trick, mit dem eine Bahn wirklich unendlich lang wird.
   Was es gibt, ist die Taeuschung, und die geht so:

   Vor und hinter die vier echten Karten wird je ein vollstaendiger Satz
   Klone gehaengt. Aus vier Karten werden zwoelf:

       [1 2 3 4]   [1 2 3 4]   [1 2 3 4]
        Klone       echte       Klone

   Gestartet wird auf der ersten echten Karte, also in der Mitte des
   Bandes. Nach links wie nach rechts stehen damit immer vier weitere
   Karten bereit - man kommt nie an einen Rand, und keiner der beiden
   Pfeile muss je abgeschaltet werden.

   Laeuft man aus dem mittleren Block heraus, wird gewartet, bis die Bahn
   still steht, und dann hart auf die gleiche Person im mittleren Block
   umgesetzt: kein Scrollen, kein Uebergang, ein einziger Sprung. Sichtbar
   ist davon nichts, weil an der neuen Stelle exakt dasselbe Bild steht
   wie an der alten. Der Selbstlauf zaehlt danach einfach weiter.

   Das Einrasten wird dabei NICHT abgeschaltet, obwohl das der erste
   Gedanke ist. Ausgeschaltet muesste es hinterher wieder eingeschaltet
   werden, und der Zeitgeber dafuer wird in einem Hintergrundtab auf eine
   Sekunde gedrosselt - gemessen: das Einrasten blieb aus. Noetig ist es
   ohnehin nicht: die angesprungene Stelle IST eine Rastposition, der
   Browser rastet also hoechstens ein halbes Pixel nach.

   Die Klone sind fuer Vorleseprogramme ausgeblendet und ihre Bilder haben
   keinen Alternativtext. Sonst stuende das Team dreimal in der Vorlesung.
   Die Punkte darunter zaehlen weiterhin vier, nicht zwoelf. Geladen wird
   nichts doppelt: die Klone zeigen auf dieselben Adressen wie die
   Originale und kommen aus dem Zwischenspeicher des Browsers.

   WIE GESCROLLT WIRD

   Die Bahn ist ein ganz normaler Bereich mit overflow-x und
   scroll-snap-type. Das ist kein Sparmodell, sondern die bessere Wahl:
   Am Telefon wischt man damit mit dem echten Schwung des Systems, die
   Tastatur funktioniert, und wer kein JavaScript hat, sieht ein sauberes
   Raster. Selbst gerechnet wird nur, was CSS nicht kann - welche Karte
   gerade in der Mitte steht und wie weit die anderen davon weg sind.

   Dieser Abstand wandert als --d (mit Vorzeichen, fuer die Drehrichtung)
   und --a (Betrag, fuer Groesse und Deckkraft) in die Karte.

   ZIEHEN MIT DER MAUS

   Nur mit Maus und Stift, nicht mit dem Finger: der Finger scrollt schon
   nativ, und beides gleichzeitig macht die Bahn zappelig.

   SELBSTLAUF

   Pause beim Ueberfahren und beim Fokus, Pause beim Bedienen - aber nur
   fuer acht Sekunden. Frueher blieb er nach der ersten Beruehrung fuer
   immer aus; das widerspricht dem Sinn eines endlos laufenden Bandes.
   Wer blaettert, will einen Moment Ruhe, nicht das Ende der Bewegung.
   Bei "Bewegung reduzieren" faengt er gar nicht erst an.
   ========================================================================== */
(function () {
  "use strict";

  var mq = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  var ruhig = !!(mq && mq.matches);

  var PFEIL_ZUR = "M12.5 3.5 6 10l6.5 6.5";
  var PFEIL_VOR = "M7.5 3.5 14 10l-6.5 6.5";

  function knopf(klasse, titel, pfad) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "kar-nav " + klasse;
    b.setAttribute("aria-label", titel);
    b.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="' + pfad + '" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function baue(bahn) {
    if (bahn.getAttribute("data-kar")) { return; }
    var echte = Array.prototype.slice.call(bahn.querySelectorAll(".team-p"));
    var n = echte.length;
    if (n < 2) { return; }
    bahn.setAttribute("data-kar", "1");

    function klone(k) {
      var c = k.cloneNode(true);
      c.classList.add("klon");
      c.setAttribute("aria-hidden", "true");
      var im = c.querySelector("img");
      if (im) { im.alt = ""; }
      return c;
    }

    var i;
    for (i = n - 1; i >= 0; i--) { bahn.insertBefore(klone(echte[i]), bahn.firstChild); }
    for (i = 0; i < n; i++) { bahn.appendChild(klone(echte[i])); }

    var karten = Array.prototype.slice.call(bahn.querySelectorAll(".team-p"));
    var basis = n;

    /* ---- Geruest ------------------------------------------------------- */
    var kar = document.createElement("div");
    kar.className = "kar";
    var fenster = document.createElement("div");
    fenster.className = "kar-fenster";

    bahn.parentNode.insertBefore(kar, bahn);
    kar.appendChild(fenster);
    fenster.appendChild(bahn);
    bahn.classList.add("kar-bahn");
    bahn.setAttribute("role", "group");
    bahn.setAttribute("aria-label", "Unser Team");

    var zur = knopf("kar-zur", "Vorherige Person", PFEIL_ZUR);
    var vor = knopf("kar-vor", "Nächste Person", PFEIL_VOR);
    kar.appendChild(zur);
    kar.appendChild(vor);

    var leiste = document.createElement("div");
    leiste.className = "kar-punkte";
    var punkte = [];
    echte.forEach(function (k, j) {
      var name = k.querySelector("b");
      var p = document.createElement("button");
      p.type = "button";
      p.className = "kar-p";
      p.setAttribute("aria-label", name ? name.textContent.trim() : "Person " + (j + 1));
      p.addEventListener("click", function () { pause(); geheZu(basis + j, true); });
      leiste.appendChild(p);
      punkte.push(p);
    });
    kar.appendChild(leiste);

    var aktiv = -1;
    var uhr = null, ruheUhr = null, weiterUhr = null;
    var zieht = false, vonX = 0, vonL = 0;

    function logisch(x) { return ((x - basis) % n + n) % n; }
    function mitte() { return bahn.scrollLeft + bahn.clientWidth / 2; }
    function stelle(x) {
      var k = karten[x];
      return Math.round(k.offsetLeft + k.offsetWidth / 2 - bahn.clientWidth / 2);
    }

    function naechste() {
      var best = 0, weit = Infinity, m = mitte();
      for (var x = 0; x < karten.length; x++) {
        var d = Math.abs(karten[x].offsetLeft + karten[x].offsetWidth / 2 - m);
        if (d < weit) { weit = d; best = x; }
      }
      return best;
    }

    /* Setzt die Markierung auf eine Karte und den passenden Punkt. Steht
       als eigene Funktion da, weil sie an ZWEI Stellen gebraucht wird: beim
       normalen Weiterscrollen und beim harten Umsetzen in den mittleren
       Block. Fehlte sie dort, bliebe die Markierung auf dem Klon stehen -
       gemessen: nach dem Sprung trug Karte 8 die Markierung, sichtbar am
       Schlagschatten der grossen Karte, der dann auf einer stand, die
       niemand sieht. */
    function markiere(x) {
      aktiv = x;
      var lg = logisch(x);
      for (var j = 0; j < punkte.length; j++) {
        punkte[j].classList.toggle("ist", j === lg);
        punkte[j].setAttribute("aria-current", j === lg ? "true" : "false");
      }
      for (var y = 0; y < karten.length; y++) {
        karten[y].classList.toggle("ist", y === x);
      }
    }

    function male() {
      var m = mitte();
      for (var x = 0; x < karten.length; x++) {
        var k = karten[x];
        var schritt = k.offsetWidth + 22;
        var d = (k.offsetLeft + k.offsetWidth / 2 - m) / schritt;
        if (d > 1.6) { d = 1.6; }
        if (d < -1.6) { d = -1.6; }
        k.style.setProperty("--d", d.toFixed(3));
        k.style.setProperty("--a", Math.abs(d).toFixed(3));
      }
      var neu = naechste();
      if (neu !== aktiv) { markiere(neu); }
    }

    function geheZu(x, weich) {
      if (x < 0) { x = 0; }
      if (x > karten.length - 1) { x = karten.length - 1; }
      try {
        bahn.scrollTo({ left: stelle(x), behavior: (weich && !ruhig) ? "smooth" : "auto" });
      } catch (e) {
        bahn.scrollLeft = stelle(x);
      }
    }

    /* Der harte Sprung in den mittleren Block: Position setzen, Markierung
       mitnehmen, fertig. Kein weiches Scrollen, kein Uebergang. */
    function umsetzen(x) {
      bahn.scrollLeft = stelle(x);
      markiere(x);
    }

    function ruhe() {
      if (zieht) { return; }
      male();
      if (aktiv >= basis && aktiv < basis + n) { return; }
      umsetzen(basis + logisch(aktiv));
    }

    /* ---- Selbstlauf ---------------------------------------------------- */
    function halt() { if (uhr) { clearInterval(uhr); uhr = null; } }
    function lauf() {
      if (ruhig || uhr) { return; }
      uhr = setInterval(function () { geheZu(aktiv + 1, true); }, 5200);
    }
    /* Bedienen heisst Pause, nicht Aus: nach acht Sekunden ohne Zutun
       laeuft das Band weiter. */
    function pause() {
      halt();
      if (weiterUhr) { clearTimeout(weiterUhr); }
      weiterUhr = setTimeout(lauf, 8000);
    }

    kar.addEventListener("mouseenter", halt);
    kar.addEventListener("mouseleave", lauf);
    kar.addEventListener("focusin", halt);
    bahn.addEventListener("touchstart", pause, { passive: true });

    zur.addEventListener("click", function () { pause(); geheZu(aktiv - 1, true); });
    vor.addEventListener("click", function () { pause(); geheZu(aktiv + 1, true); });

    kar.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { pause(); geheZu(aktiv + 1, true); e.preventDefault(); }
      else if (e.key === "ArrowLeft") { pause(); geheZu(aktiv - 1, true); e.preventDefault(); }
    });

    /* ---- Ziehen mit Maus oder Stift ------------------------------------ */
    bahn.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") { return; }
      zieht = true;
      vonX = e.clientX;
      vonL = bahn.scrollLeft;
      bahn.classList.add("zieht");
      pause();
    });
    window.addEventListener("pointermove", function (e) {
      if (!zieht) { return; }
      bahn.scrollLeft = vonL - (e.clientX - vonX);
    });
    window.addEventListener("pointerup", function () {
      if (!zieht) { return; }
      zieht = false;
      bahn.classList.remove("zieht");
      geheZu(naechste(), true);
    });

    /* ---- Nachziehen ---------------------------------------------------- */
    var wartet = false;
    bahn.addEventListener("scroll", function () {
      if (!wartet) {
        wartet = true;
        requestAnimationFrame(function () { wartet = false; male(); });
      }
      if (ruheUhr) { clearTimeout(ruheUhr); }
      ruheUhr = setTimeout(ruhe, 170);
    }, { passive: true });

    function neuAusrichten() { male(); geheZu(aktiv, false); }
    window.addEventListener("resize", neuAusrichten);
    /* Nach dem Laden der Portraits stehen die Karten erst an ihrem Platz. */
    window.addEventListener("load", neuAusrichten);

    /* Startstellung: erste echte Karte in der Mitte. */
    umsetzen(basis);
    male();

    /* Erst anfangen, wenn das Karussell ueberhaupt zu sehen ist - sonst
       laeuft es die ganze Seite lang unbeachtet durch. */
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { lauf(); } else { halt(); }
      }, { threshold: 0.35 }).observe(kar);
    } else {
      lauf();
    }
  }

  function alle() {
    Array.prototype.forEach.call(document.querySelectorAll(".team"), baue);
  }

  alle();
  document.addEventListener("shopify:section:load", alle);
})();
